export default __webpack_public_path__ + "static/media/signin-hero.aa460588.jpg";